import Component from 'inferno-component';
import PartnersContainer from '../partners/Partners';
import FeaturedLocationsContainer from '../locations/FeaturedLocations';
import Pros from '../pros/Pros';
import Cover from '../cover/Cover';
import Contacts from '../contact/Contacts';
import About from '../about/About';

export default class IndexPage extends Component {

  render() {
    return (
      <div style={{backgroundColor: 'white'}}>
        <Cover />
        <About />
        <Pros />
        <FeaturedLocationsContainer />
        <PartnersContainer />
        <Contacts />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/IndexPage.js